import React, { useState, useEffect, Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Button, ButtonToolbar, Label } from 'reactstrap';
import InfoIcon from '@material-ui/icons/Info';
import Select from '../../../shared/components/form/Select';
import renderCheckBoxField from '../../../shared/components/form/CheckBox';

const StudentFilter = (props) => {
  const {
    classes,
    responsibles,
    menus,
    lastFilter,
    initialize,
    t,
    filterClick,
  } = props;

  const [filter, setFilter] = useState({
    onlyActive: true,
  });

  const filterChange = (field, value) => {
    const updatedFilter = { ...filter };
    updatedFilter[field] = value;
    setFilter(updatedFilter);
  };

  const filterActiveCheckChange = (evt) => {
    if (evt) {
      const updatedFilter = { ...filter };
      updatedFilter[evt.target.name] = evt.target.checked;
      filterChange('onlyActive', evt.target.checked);
    } else {
      filterChange('onlyActive', true);
    }
  };

  useEffect(() => {
    if (lastFilter) {
      setFilter(lastFilter);
      initialize(lastFilter);
    } else {
      initialize(filter);
    }
  }, []);

  return (
    <Fragment>
      <form className="form">
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.classes-names')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="classes"
              type="text"
              closeMenuOnSelect={false}
              component={Select}
              isMulti
              options={classes}
              onChange={(values) => filterChange('classes', values)}
              placeholder={t('general.classes-names')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.responsible')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="responsibles"
              type="text"
              closeMenuOnSelect={false}
              component={Select}
              isMulti
              options={responsibles}
              onChange={(values) => filterChange('responsibles', values)}
              placeholder={t('general.responsible')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">{t('general.menus')}</span>
          <div className="form__form-group-field">
            <Field
              name="menus"
              type="text"
              closeMenuOnSelect={false}
              component={Select}
              isMulti
              options={menus}
              onChange={(values) => filterChange('menus', values)}
              placeholder={t('general.menus')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <div className="form__form-group-field">
            <Field
              name="onlyActive"
              component={renderCheckBoxField}
              defaultValue
              className="colored-click"
              onChange={filterActiveCheckChange}
            />
            <Label
              style={{ paddingRight: '5px' }}
              className="form__form-group-label"
            >
              {t('screens.mnt_alunos.showOnlyActives')}
            </Label>
            <span
              className="tooltip-test"
              title={t('screens.mnt_alunos.InfoActives')}
            >
              <InfoIcon />
            </span>
          </div>
          <ButtonToolbar className="filter-button">
            <Button color="success" onClick={() => filterClick(filter)}>
              {t('general.filter')}
            </Button>
          </ButtonToolbar>
        </div>
      </form>
    </Fragment>
  );
};

StudentFilter.propTypes = {
  t: PropTypes.func.isRequired,
  filterClick: PropTypes.func.isRequired,
  initialize: PropTypes.func.isRequired,
  classes: PropTypes.arrayOf(PropTypes.shape).isRequired,
  responsibles: PropTypes.arrayOf(PropTypes.shape).isRequired,
  menus: PropTypes.arrayOf(PropTypes.shape).isRequired,
  lastFilter: PropTypes.shape(PropTypes.shape),
};

StudentFilter.defaultProps = {
  lastFilter: null,
};

export default reduxForm({
  form: 'StudentFilter',
})(withTranslation('common')(StudentFilter));
